import { PromotionsBlockProps } from '../types';
import './styles.scss';
import { useIsDesktop } from '../../../utils';

function ProductMadnessValueBlock({
    mobileLogoImage,
    desktopLogoImage,
    backgroundImage,
    storeSaleImage,
    playerLevelImage
}: PromotionsBlockProps) {
    const isDesktop = useIsDesktop();
    return (
        <>
            {isDesktop && (
                <div className={'jackpot-slots-desktop-logo'}>
                    <img src={desktopLogoImage} alt={'store logo'} />
                </div>
            )}
            <div className={'jackpot-slots-promotions'}>
                {!isDesktop && (
                    <div className={'jackpot-slots-promotions__logo'}>
                        <img src={mobileLogoImage} alt={'logo'} />
                    </div>
                )}

                <div className={'jackpot-slots-promotions__background'}>
                    <img src={backgroundImage} alt={'background'} />
                </div>

                <div className={'jackpot-slots-promotions__images_container'}>
                    <div className={'jackpot-slots-promotions__inner-image'}>
                        {playerLevelImage && (
                            <img
                                src={playerLevelImage}
                                alt={'player-level'}
                            ></img>
                        )}
                    </div>

                    <div className={'jackpot-slots-promotions__inner-image'}>
                        {storeSaleImage && (
                            <img src={storeSaleImage} alt={'store-sale'}></img>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductMadnessValueBlock;
